import React, { useState } from "react";

const FilterPopUp = ({ isOpen, close,setSelectedTab, fetchdata,setSelectedFilterscounts}) => {
  const [selectedFilters, setSelectedFilters] = useState({
    reviewedStatus: [],
    billing: [],
    enrolledPrograms: [],
    unassigns: [],
  });

  const handleButtonClick = (category, value) => {
    setSelectedFilters((prevFilters) => {
      const categoryFilters = prevFilters[category];
      if (categoryFilters.includes(value)) {
        return {
          ...prevFilters,
          [category]: categoryFilters.filter((item) => item !== value),
        };
      } else {
        return {
          ...prevFilters,
          [category]: [...categoryFilters, value],
        };
      }
    });
  };

  const handleSubmit = async() => {
    console.log("Selected Filters:", selectedFilters);
    const payload={
        "status": selectedFilters.reviewedStatus,
        billing :selectedFilters.billing,
enroll: selectedFilters.enrolledPrograms,
deviceUnassign :selectedFilters.unassigns
    }
await fetchdata(payload)
setSelectedFilterscounts(selectedFilters)
setSelectedFilters({
    reviewedStatus: [],
    billing: [],
    enrolledPrograms: [],
    unassigns: [],
  })
  setSelectedTab(0)
    close(false); // Close modal after submission
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-auto overflow-scroll custom-scrollbar">
          <div className="bg-white rounded-lg shadow-lg w-full lg:max-w-[60%] max-w-[90%] mx-4 sm:mx-auto my-4">
            {/* Modal Header */}
            <div className="flex justify-between items-center bg-[#E179544A] border-b px-4 py-3">
  <h2 className="text-xl  font-semibold">RPM Filter</h2>
  <button
    onClick={() => {
      setSelectedFilters({
        reviewedStatus: [], 
        billing: [],
        enrolledPrograms: [],
        unassigns: [],
      });
      close(false);
    }}
    className="text-gray-500 hover:text-gray-700 text-2xl p-2"
  >
    &times;
  </button>
</div>


            {/* Modal Body */}
            <div className="p-4 ">
              {/* Reviewed Status */}
              <div className="mb-4">
                <h3 className="text-sm text-[#E17954] font-semibold text-start">
                  Reviewed Status
                </h3>
                <div className="flex  flex-wrap items-center gap-2 ">
  {[
    { display: "Pending Review", value: "PendingReview" },
    { display: "Reviewed", value: "Reviewed" },
    { display: "Needs Follow Up", value: "NeedsFollowUp" },
    { display: "20 min < 16 days", value: "Rew20mlt16d" },
    { display: "16 days < 20 min", value: "Rew16dlt20m" },
    { display: "16 days & 20 min", value: "Rew16dand20m" },
    { display: "16 days > 20 min", value: "Rew16dgt20m" },
    { display: "Pending Authorization", value: "PendingAuthorization" },
    { display: "BPP Above 150", value: "BppAbove150" },
  ].map((item) => (
    <button
      key={item.value}
      className={`${
        selectedFilters.reviewedStatus.includes(item.value)
           ? "bg-gray-200 border-[1.5px] bg-[white]"
          : "bg-white border-[1.5px] text-gray-700"
      } text-[12px] h-6 px-4 rounded-full`}
      onClick={() => handleButtonClick("reviewedStatus", item.value)}
      style={{fontWeight:'500'}}
    >
      {item.display}
    </button>
  ))}
</div>

              </div>

              {/* Billing */}
              <div className="mb-4">
                <h3 className="text-sm text-[#E17954] font-semibold text-start">Billing</h3>
                <div className="flex flex-wrap items-center gap-2">
  {[
    { display: "Eligible", value: "Eligible" },
    { display: "Not-Eligible", value: "NotEligible" },
    { display: "High Risk", value: "HighRisk" },
    { display: "Callback", value: "CallBack" },
    { display: "Device Recall", value: "DeviceBack" },
  ].map((item) => (
    <button
      key={item.value}
      className={`${
        selectedFilters.billing.includes(item.value)
          ? "bg-gray-200 border-[1.5px] bg-[white]"
          : "bg-white border-[1.5px] text-gray-700"
      } text-[12px] h-6 px-4 rounded-full`}
      onClick={() => handleButtonClick("billing", item.value)}
      style={{fontWeight:'500'}}

    >
      {item.display}
    </button>
  ))}
</div>

              </div>

              {/* Enrolled Programs */}
              <div className="mb-4">
                <h3 className="text-sm text-[#E17954] font-semibold text-start">
                  Enrolled Programs
                </h3>
                <div className="flex flex-wrap items-center gap-2">
  {[
    { display: "BPM", value: "BPP" },
    { display: "WLM", value: "WLM" },
  ].map((item) => (
    <button
      key={item.value}
      className={`${
        selectedFilters.enrolledPrograms.includes(item.value)
            ? "bg-gray-200 border-[1.5px] bg-[white]"
          : "bg-white border-[1.5px] text-gray-700"
      } text-[12px] h-6 px-4 rounded-full`}
      onClick={() => handleButtonClick("enrolledPrograms", item.value)}
      style={{fontWeight:'500'}}

    >
      {item.display}
    </button>
  ))}
</div>

              </div>

              {/* Device Un-assign */}
              <div className="mb-4">
                <h3 className="text-sm text-[#E17954] font-semibold text-start">
                  Device Un-assign
                </h3>
                <div className="flex flex-wrap items-center gap-2">
  {[
    { display: "BPM", value: "bpp-u" },
    { display: "WLM", value: "wlm-u" },
  ].map((item) => (
    <button
      key={item.value}
      className={`${
        selectedFilters.unassigns.includes(item.value)
             ? "bg-gray-200 border-[1.5px] bg-[white]"
          : "bg-white border-[1.5px] text-gray-700"
      } text-[12px] h-6 px-4 rounded-full`}
      onClick={() => handleButtonClick("unassigns", item.value)}
      style={{fontWeight:'500'}}

    >
      {item.display}
    </button>
  ))}
</div>

              </div>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-end items-center gap-2 p-4 border-t">
              <button
                onClick={() => close(false)}
                className="border-[#ccc] font-semibold border-[1.5px] text-gray-700 text-sm px-4 py-2 rounded-lg"
              >
                Clear
              </button>
              <button
                onClick={handleSubmit}
                className="bg-[#E17954] text-white text-sm px-4 py-2 rounded-lg"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterPopUp;
